import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Link, Box, Structure, Text, Section, Strong, Span, List, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"prodazha-elektronnykh-tovarov-v-telegram"} />
		<Helmet>
			<title>
				Как продавать электронные товары в Телеграм
			</title>
			<meta name={"description"} content={"Продажа цифровых товаров при помощи Telegram бота"} />
			<meta property={"og:title"} content={"Как продавать электронные товары в Телеграм"} />
			<meta property={"og:description"} content={"Продажа цифровых товаров при помощи Telegram бота"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
		>
			<Override
				slot="Content"
				grid-template-columns="3fr 1fr"
				nout-grid-template-columns="3fr 2fr"
				lg-grid-template-columns="1fr 1fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
				display="grid"
			>
				<Override slot="cell-0">
					<LinkBox href="/">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
							justify-content="flex-start"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override slot="Button Text" nout-text-transform="uppercase" nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif" nout-letter-spacing="1px" />
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="32px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="/instrukciya/#shop"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Создание интернет-магазина
							</Link>
							<Link
								href="/instrukciya/#bot"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Подключение бота
							</Link>
							<Link
								href="/instrukciya/#pay"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Онлайн оплата
							</Link>
							<Link
								href="/instrukciya/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Инструкция
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
				/>
				<Override slot="cell-1">
					<Link
						href="https://t.me/uShopWebBot?start=web"
						color="--white"
						font="--button"
						text-decoration-line="initial"
						padding="12px 24px 12px 24px"
						background="--dark"
						border-radius="50px"
						transition="--opacityOut"
						hover-opacity=".8"
						target="_blank"
						md-padding="12px 20px 12px 20px"
					>
						Создать веб-бота
					</Link>
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section padding="140px 0 140px 0" background="linear-gradient(0deg,rgba(2, 2, 2, 0.58) 0%,rgba(2, 2, 2, 0.58) 100%),rgba(0, 0, 0, 0) url(https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1200) center center/cover repeat scroll padding-box" sm-padding="120px 0 120px 0">
			<Override slot="SectionContent" align-items="flex-start" md-align-items="center" />
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
				color="--white"
				as="h1"
				md-text-align="center"
			>
				Продажа электронных товаров в Telegram
			</Text>
			<Text margin="8px 0px 48px 0px" font="--headline3" color="--white" md-text-align="center">
				Рассказываем о возможности продажи цифровых товаров внутри мессенджера Телеграм
			</Text>
			<Link
				href="https://t.me/DigitalGood_Bot"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
				sm-text-align="center"
			>
				Пример магазина электронных товаров
			</Link>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="30px 0 30px 0" md-padding="30px 0 90px 0">
			<Text
				id="shop"
				margin="0px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				Какие электронные товары можно продавать в Телеграм
			</Text>
			<Text margin="0px 0px 12px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Давайте сначала разберем какие именно электронные и цифровые товары существуют:{" "}
			</Text>
			<List
				margin="0px 0px 0px 0px"
				padding="0px 0px 0px 20px"
				list-style-type="disc"
				as="ul"
				font="--base"
				color="--dark"
			>
				<Text margin="0px 0px 6px 0px">
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Видео;
					</Strong>
				</Text>
				<Text margin="0px 0px 6px 0px">
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Аудио;
					</Strong>
				</Text>
				<Text margin="0px 0px 6px 0px">
					<Strong>
						Электронные книги;
					</Strong>
				</Text>
				<Text margin="0px 0px 6px 0px">
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Ключи и сертификаты;
					</Strong>
				</Text>
				<Text margin="0px 0px 6px 0px">
					<Span
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Доступы к курсам или вебинарам;
						</Strong>
					</Span>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Прочее.{" "}
					</Strong>
					В эту категорию мы отнесём любые другие файлы, которые вы можете положить в архив и продавать, возможно это какие-то программы, скрипты, а может быть просто фотографии\рисунки.
				</Text>
			</List>
			<Text margin="12px 0px 12px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Каждый может продавать электронные товары в Telegram. Для примера профессионал в веб-дизайне мог бы создать потрясающую книгу для продажи разработчикам и дизайнерам, а тренеры по фитнесу смогут продавать программу тренировок и питания по всему миру. А если у вас уже есть магазин с физическими товарами, например с одеждой, то вы можете дополнительно продавать руководство по стилю, тем самым расширить свой каталог.
			</Text>
			<Text
				id="shop"
				margin="18px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
				color="--dark"
			>
				Как продавать цифровые товары в Телеграм
			</Text>
			<Text margin="0px 0px 12px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Вы можете продавать цифровые товары в Telegram с помощью{" "}
				<Link
					href="/delayem-magazin-v-telegram/"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					канала
				</Link>
				{" "}и{" "}
				<Link href="/instrukciya/" text-decoration-line="initial" color="--primary">
					бота-каталога
				</Link>
				. Для организации такого магазина не требуется настраивать способы доставки, так как товар является файлом или кодом, то есть покупатель сможет скачать его после оплаты или получить уникальный код.{"\n\n\n\n"}
			</Text>
			<Image
				display="block"
				border-width="1px"
				border-style="solid"
				border-color="--color-dark"
				src="https://ukit.top/360/magazine3.gif"
			/>
			<Text margin="4px 0px 0px 0px" color="--grey" font="italic 500 16px/160% --fontFamily-googleMontserrat">
				Продажа электронных товаров через бота{" "}
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					<Link href="https://t.me/DigitalGood_Bot" target="_blank" color="--primary" text-decoration-line="initial">
						@DigitalGood_Bot
					</Link>
				</Span>
			</Text>
			<Text margin="24px 0px 0px 0px" font="--base" color="--dark" as="h4">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Инструкция по созданию магазина электронных товаров в Telegram
				</Strong>
			</Text>
			<Text margin="12px 0px 0px 0px" font="--base" color="--dark">
				1. Первоначально нам необходимо создать бота-каталога, в который мы подключим онлайн оплату и добавим товар. Как именно создать телеграм-бота для продажи товара, вы можете прочитать в нашей{" "}
				<Link
					href="/instrukciya/"
					color="--primary"
					text-decoration-line="initial"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					инструкции
				</Link>
				;
			</Text>
			<Text margin="12px 0px 12px 0px" font="--base" color="--dark">
				2. Как только мы создадим бота и подключим онлайн оплату, нам будет необходимо добавить товар, сделать это мы можем в модуле "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Интернет-магазин
				</Strong>
				", в разделе "
				<Strong>
					Управление товарами
				</Strong>
				":{" "}
			</Text>
			<Image
				display="block"
				border-width="1px"
				border-style="solid"
				border-color="--color-dark"
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/elecktro-tovari1.png?v=2023-02-03T22:46:57.402Z"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elecktro-tovari1.png?v=2023-02-03T22%3A46%3A57.402Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elecktro-tovari1.png?v=2023-02-03T22%3A46%3A57.402Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elecktro-tovari1.png?v=2023-02-03T22%3A46%3A57.402Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elecktro-tovari1.png?v=2023-02-03T22%3A46%3A57.402Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elecktro-tovari1.png?v=2023-02-03T22%3A46%3A57.402Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elecktro-tovari1.png?v=2023-02-03T22%3A46%3A57.402Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elecktro-tovari1.png?v=2023-02-03T22%3A46%3A57.402Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="12px 0px 12px 0px" font="--base" color="--dark">
				3. В этом разделе необходимо нажать на кнопочку "Добавить товар" и вы будете перенаправлены на страницу добавления товара. На этой странице вам необходимо выбрать{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					категорию
				</Strong>
				{" "}вашего товара, добавить{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					название
				</Strong>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					,
				</Span>
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{" "}изображение{" "}
				</Strong>
				и{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					описание{" "}
				</Strong>
				товара. После же вам нужно выбрать{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					тип товара
				</Strong>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					:
				</Span>
			</Text>
			<Image
				display="block"
				border-width="1px"
				border-style="solid"
				border-color="--color-dark"
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/eletcro-tovari-v-telegram.png?v=2023-02-03T22:54:04.974Z"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/eletcro-tovari-v-telegram.png?v=2023-02-03T22%3A54%3A04.974Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/eletcro-tovari-v-telegram.png?v=2023-02-03T22%3A54%3A04.974Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/eletcro-tovari-v-telegram.png?v=2023-02-03T22%3A54%3A04.974Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/eletcro-tovari-v-telegram.png?v=2023-02-03T22%3A54%3A04.974Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/eletcro-tovari-v-telegram.png?v=2023-02-03T22%3A54%3A04.974Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/eletcro-tovari-v-telegram.png?v=2023-02-03T22%3A54%3A04.974Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/eletcro-tovari-v-telegram.png?v=2023-02-03T22%3A54%3A04.974Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="12px 0px 12px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				В случае если вы добавляете товар через бота, то тип товара выбирается здесь:
			</Text>
			<Image
				display="block"
				border-width="1px"
				border-style="solid"
				border-color="--color-dark"
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/cifrabot.png?v=2024-12-01T21:25:43.205Z"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/cifrabot.png?v=2024-12-01T21%3A25%3A43.205Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/cifrabot.png?v=2024-12-01T21%3A25%3A43.205Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/cifrabot.png?v=2024-12-01T21%3A25%3A43.205Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/cifrabot.png?v=2024-12-01T21%3A25%3A43.205Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/cifrabot.png?v=2024-12-01T21%3A25%3A43.205Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/cifrabot.png?v=2024-12-01T21%3A25%3A43.205Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/cifrabot.png?v=2024-12-01T21%3A25%3A43.205Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="12px 0px 12px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Так как мы планируем продавать электронные товары, то нам необходимо выбрать либо "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Товар является файлом
				</Strong>
				", либо "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Товар электронный код
				</Strong>
				".
				<br />
				При продаже электронного кода, вы можете указать один или несколько уникальных кодов, в случае если вы укажите несколько, то с каждой покупкой каждому пользователю отправляется уникальный код. А при продаже товара, который является файлом вашим покупателям будет просто отправляться этот файл который вы загрузите, файл отправляется строго после оплаты.
			</Text>
			<Text margin="0px 0px 12px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				4. После чего вам необходимо будет установить галочку в поле "
				<Strong>
					Отображать в Telegram shop
				</Strong>
				" и нажать кнопочку "
				<Strong>
					Добавить
				</Strong>
				".
			</Text>
			<Text margin="0px 0px 12px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				5. В настройках уведомлений не забудьте активировать выдачу товара (файлов, кодов и пр.) в TGShop
			</Text>
			<Image
				display="block"
				border-width="1px"
				border-style="solid"
				border-color="--color-dark"
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/notlifyfile.png?v=2023-11-15T12:27:26.381Z"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/notlifyfile.png?v=2023-11-15T12%3A27%3A26.381Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/notlifyfile.png?v=2023-11-15T12%3A27%3A26.381Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/notlifyfile.png?v=2023-11-15T12%3A27%3A26.381Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/notlifyfile.png?v=2023-11-15T12%3A27%3A26.381Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/notlifyfile.png?v=2023-11-15T12%3A27%3A26.381Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/notlifyfile.png?v=2023-11-15T12%3A27%3A26.381Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/notlifyfile.png?v=2023-11-15T12%3A27%3A26.381Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="30px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				6. Готово, наш магазин создан и заполнен товаром, теперь вам необходимо заняться его продвижением, инструкцию по продвижению, вы можете прочитать{" "}
				<Link
					href="/prodvizhenie-internet-magazina-v-telegram/"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					здесь
				</Link>
			</Text>
			<Text
				id="shop"
				margin="30px 0px 0px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
				color="--dark"
			>
				Ручная выдача товара
			</Text>
			<Text margin="20px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Если у вас не подключена онлайн оплата, то цифровой товар вы можете выдавать вручную через раздел "Управление заказами" (зайти в этот раздел вы можете при помощи команды{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					/admin
				</Strong>
				{" "}в вашем боте и выбрать вкладку "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					🛒 Последние заказы
				</Strong>
				"). Вам нужно будет выбрать какой заказ вы хотите отправить и нажать на кнопку "Отправить", предварительно изменив статус товара на "Оплачен" вручную:{"  "}
			</Text>
			<Image
				display="block"
				border-width="1px"
				border-style="solid"
				border-color="--color-dark"
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/tovarsend.png?v=2024-03-12T14:15:43.655Z"
				margin="10px 0px 0px 0px"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovarsend.png?v=2024-03-12T14%3A15%3A43.655Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovarsend.png?v=2024-03-12T14%3A15%3A43.655Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovarsend.png?v=2024-03-12T14%3A15%3A43.655Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovarsend.png?v=2024-03-12T14%3A15%3A43.655Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovarsend.png?v=2024-03-12T14%3A15%3A43.655Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovarsend.png?v=2024-03-12T14%3A15%3A43.655Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovarsend.png?v=2024-03-12T14%3A15%3A43.655Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Магазин в Телеграм под ключ
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Создание сайтов, магазинов, порталов и лендингов под ключ. Помощь по сайтам,
				<br />
				SEO-продвижение и консультации с вебмастерами.
			</Text>
			<Link
				href="https://bot.divly.pro/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox href="https://t.me/uShopWeb" target="_blank" transition="--opacityOut" hover-opacity="0.7">
				<Icon category="fa" icon={FaTelegram} size="24px" color="--white" />
			</LinkBox>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});